import React  from "react";
import classes from "../CSS/home.module.css";
import protest from "../assets/protest.jpg";
import banner from "../assets/banner.png";
import texture from "../assets/texture.jpg"
import {Row,Col} from "react-bootstrap";
import { Card } from 'antd';
import SmallHelp from "./small";
import Aos from "aos";
import "aos/dist/aos.css";
import CustomNavbar from "../components/navbar";
import Footer from "../components/footer";

const Home = ()=>{
    Aos.init({duration:1000,
        })
    return(
        <>
            <div style={{ backgroundImage:`url(${protest})`,
                color:"white",
                fontFamily:"Lexend Giga"}} className={classes.parallax}>
                        <CustomNavbar />
                        <div className={classes.parallax} style={{
                             display:"flex",
                             alignItems:"center",
                             justifyContent:"center",
                             flexDirection:"column",
                        }} >

                    <center><h1 data-aos="fade-down" className={classes.Header} >Have a voice. Have a choice.</h1></center>
                    </div>
            </div>
            <div style={{backgroundImage:`url(${texture})`,
                backgroundSize:"100% 100%",
                }} >

                    <div style={{display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column",}} className="container-fluid">
                    <Row>
                        <Col style={{display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column",}} md={4} sm={12}>
                        <Card data-aos="flip-left" style={{marginBottom:"20px"}} hoverable={true} className={classes.Card}>
                            <div className="container">
                                <Row>
                                    <Col sm={5} style={{display:"flex",
                                        alignItems:"center",
                                        justifyContent:"center",
                                        flexDirection:"column",}}>
                                    <i style={{backgroundColor:"#104F67",color:"white",padding:"10%",borderRadius:"50%"}} class="fas fa-hands-helping fa-3x"></i>
                                    </Col>
                                    <Col sm={7} >
                                        <div className="container">
                                            <center><h3 style={{color:"#efb1ff",fontWeight:"bold"}}>MISSION</h3></center>
                                            <center><p>To establish the norms of Gender Equality and Gender Justice Regime.</p></center>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Card>
                        </Col>
                        <Col style={{display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column",}} md={4} sm={12}>
                        <Card data-aos="flip-left" style={{marginBottom:"20px"}} hoverable={true} className={classes.Card} >
                            <div className="container">
                                <Row>
                                    <Col sm={5} style={{display:"flex",
                                        alignItems:"center",
                                        justifyContent:"center",
                                        flexDirection:"column",}}>
                                    <i style={{backgroundColor:"#29BFA4",color:"white",padding:"10%",borderRadius:"50%"}} class="far fa-lightbulb fa-3x"></i>
                                    </Col>
                                    <Col sm={7} >
                                        <div className="container">
                                            <center><h3 style={{color:"#efb1ff",fontWeight:"bold"}}>VISION</h3></center>
                                            <center><p>To stimulate and influence women in preferring jobs in STEM development.</p></center>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Card>
                        </Col>
                        <Col style={{display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column",}} md={4} sm={12}>
                        <Card data-aos="flip-left" style={{marginBottom:"20px"}} hoverable={true} className={classes.Card}>
                            <div className="container">
                                <Row>
                                    <Col sm={5} style={{display:"flex",
                                        alignItems:"center",
                                        justifyContent:"center",
                                        flexDirection:"column",}}>
                                    <i style={{backgroundColor:"#0BA0DB",color:"white",padding:"10%",borderRadius:"50%"}} class="fas fa-praying-hands fa-3x"></i>
                                    </Col>
                                    <Col sm={7} >
                                        <div className="container">
                                            <center><h3 style={{color:"#efb1ff",fontWeight:"bold"}}>GOAL</h3></center>
                                            <center><p>Embracing the UNTOLD history of Gender Inequality.</p></center>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Card>
                        </Col>
                    </Row>
                    <br/><br/>
                    <div className="container" style={{display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column",
                }}>
                        <center><h2 data-aos="fade-up" style={{fontWeight:"bold",borderBottom:"2px solid #efb1ff",paddingBottom:"20px"}}>ABOUT</h2></center>
                        <br/>
                        <center><p data-aos="fade-up" style={{fontSize:"18px",fontWeight:"500"}}>A student level initiative to encourage and inspire people to share their stories and reach out to the ones seeking guidance. To establish the norms of Gender Equality and Gender Justice Regime. Posing an end to the existence of this conventional trait of Gender Inequality, and to accept and behold the dynamics of women in STEM development. </p></center>
                    </div>
                    <br/><br/>
                    
                </div>
            </div>
           
            <div><Footer/></div>
                

        </>
    )
}
export default Home
//"height:1000px;background-stcolor:red;font-size:36px"